<div class="edit-page">

  <div class="visitor">

    <button class="close" (click)="close()">
      <img
        class="cross-icon"
        src="icons/profile-close.svg"
      />
    </button>

    <span class="visitor-txt">
      Edit Phone
    </span>

  </div>

  <p class="form-header">
    Update phone number
  </p>

  <input
    type="text"
    maxlength="10"
    class="text-box-active"
    [(ngModel)]="phoneNumber"
    placeholder="Enter Phone Number"
  />

  @if(errorMessage !== ''){
    <div class="error">

      <span class="err-message">
        {{ errorMessage }}
      </span>

    </div>
  }

  <div class="action-row">

    <button
      class="ac-secondary-btn"
      (click)="close()"
    >
      Cancel
    </button>

    <button
      class="primary-btn"
      (click)="continue()"
    >
      Save
    </button>

  </div>

</div>